import styled from "styled-components";

import { SimpleUserInitialsNameContainer } from "shared/components/atoms/SimpleUserInitials/styles";

export const TagCardContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  width: fit-content;
  padding: 0.375rem 0.75rem;

  background-color: ${({ theme }) => theme.colors.primary}29;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50rem;

  p {
    color: ${({ theme }) => theme.groups.primaryText} !important;
    font: 400 0.813rem/1.188rem "Inter";
    margin: 0;
  }

  .x-icon {
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
      stroke: ${({ theme }) => theme.groups.primaryText};
      width: 1rem;
      height: 1rem;
    }
  }

  .user-infos {
    display: flex;
    align-items: center;
  }

  .userPhoto {
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 50%;
  }

  ${SimpleUserInitialsNameContainer} {
    width: 24px;
    height: 24px;
  }

  .user-text-infos {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin-left: 1rem;
  }

  .userName {
    color: ${({ theme }) => theme.groups.primaryText};
    font: 400 0.813rem/1.188rem "Inter";
  }
  .userEmail {
    font-weight: 400;
    color: ${({ theme }) => theme.groups.secondaryText};
    font-size: 14px;
    text-align: start;
  }
`;
